export default "__VITE_ASSET__r7nHf$LbPBBCS3bL4cK2xw__"